<template>
    <div>
      <div v-if="busy" class="d-flex justify-content-center">
        <b-spinner label="Loading..." class="branded"></b-spinner>
      </div>
      <b-tabs pills class="branded mb-4" content-class="mt-3 mb-4" v-if="categories.length > 0 && !busy">
            <Tab v-for="(cat, key) in categories" :tab="cat" :block="block" :key="`tab-${key}-${block.id}`" @tabClick="onCatClick"></Tab>
            <component :is="isList ? 'ul' : 'div'" :class="isList ? 'list-group list-group-flush bg-white' : 'row'">
                <ProductBody
                    v-for="product in products"
                    :colSize="getColSize"
                    :block="block"
                    :product="product"
                    :organization="organization"
                    v-model="invoice"
                    :key="`product-${block.id}-${product.id}`"
                    :isList="isList"
                />
            </component>
      </b-tabs>
      <b-button
        id="floating-cart"
        v-if="tab == 0 && !!invoice && invoice.invoice_items.length > 0"
        variant="branded"
        class="shadow"
        :href="`${iframeUrlPrefix}/org/${this.organization.id}/checkout`"
      >
        <i class="fa fa-fw fa-shopping-cart"></i>
        <sup>
            <b-badge variant='success' pill>
                {{ invoice.invoice_items.length }}
            </b-badge>
        </sup>
        {{ trans('checkout') }}
      </b-button>
    </div>
  </template>

  <style>
    #floating-cart {
      position: fixed;
      bottom: 2em;
      right: 2em;
    }
    .nav-pills.small.short a.nav-link {
      padding: 0.25rem 1rem;
    }
  </style>

  <script>
    import CartLink from './CartLink'
    import ProductBody from './ProductBody'
    import Tab from './Tab'
    import querystring from 'querystring'
    import Dollar from './../billing/Dollar'

    export default {
      props: {
        organization: Object,
        block: Object,
        adminCanModifyPrice: Boolean,
      },
      components: {
        Tab,
        Dollar,
        ProductBody,
        CartLink,
      },
      data() {
        let query = querystring.parse(window.location.search.substring(1))
        return {
          trans: trans,
          moment: moment,
          iframeUrlPrefix: _.iframeUrlPrefix,
          busy: false,
          error: null,
          tab: 0,
          tabs: 0,
          invoice: undefined,
          vms: [],
          tag: this.allTags && this.allTags.length > 0 ? this.allTags[0].name : null,
          categories: [],
          tags: [],
          products: [],
          items: [],
          question: {},
          amClass: {},
          isList: this.block.meta && this.block.meta.form && this.block.meta.form.list_view ? true : false
        }
      },
      watch: {
        invoice() {
          _.each(this.vms, vm => {
            vm.invoice = this.invoice
          });
          if (this.invoice != null) {
            window.cartButton.invoice = this.invoice
          }
        },
        tag() {
          this.toggleVisibleProductsBySelectedTag()
        },
        block() {
          this.isList = this.block.meta && this.block.meta.form && this.block.meta.form.list_view ? true : false
          this.load() // if block changes, we change
        }
      },
      methods: {
        toggleVisibleProductsBySelectedTag() {
          _.each(this.products, p => {
            const el = document.getElementById('product-card-' + p.id).parentNode
            const show = this.tag ? _.find(p.tags, {name: this.tag}) : true
            el.style.display = show ? 'block' : 'none'
          })
        },
        onCheckout() {
          window.location = `${_.iframeUrlPrefix}/org/${this.organization.id}/checkout#form`
        },
        onEmptyCart() {
          this.tab = 1
          this.$nextTick(() => {
            this.invoice = null
          })
        },
        onCatClick(tab) {
          let ids = []
          this.getChilds(ids, tab)
          _.each(this.products, p => {
            const el = document.getElementById(`product-card-${this.block.id}-${p.id}`).parentNode
            const show = ids.includes(p.category_id)
            el.style.display = show ? 'block' : 'none'
          })
        },
        getChilds(childs, tab){
          childs.push(tab.id)
          if (tab.children) {
              tab.children.map((child) => {
                  this.getChilds(childs, child);
              });
          }
        },
        loadCart() {
          this.busy = true
          this.error = null
          return axios.get(`/org/${this.organization.id}/cart`)
          .then(response => {
            this.busy = false
            this.invoice = !_.isEmpty(response.data) ? response.data : null

            if (this.invoice) {
                if (this.block.meta && this.block.meta.form && this.block.meta.form.default_form){
                    //this.switchForm(this.invoice.ucid, this.block.meta.form.default_form)
                }
            }

          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        },
        loadProducts() {
          if (this.block.meta && this.block.meta.form.items_type && !this.block.meta.form.items_type.includes('products')){
            return new Promise((resolve) =>  {return resolve()})
          }
          this.busy = true
          this.error = null
          return axios.get(`/org/${this.organization.id}/products?no_categories=true`)
          .then(response => {
            this.busy = false
            this.items.push(...response.data.products)
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        },
        loadMemberships() {
          if (this.block.meta && this.block.meta.form && !this.block.meta.form.items_type.includes('memberships')){
            return new Promise((resolve) =>  {return resolve()})
          }

          this.busy = true
          this.error = null
          return axios.get(`/org/${this.organization.id}/memberships?no_categories=true`)
          .then(response => {
            this.busy = false
            this.items.push(...response.data.memberships)
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        },
        findWithChild(array, id){
            let result;
            array.some(o => result = o.id === id ? o : this.findWithChild(o.children || [], id));
            return result;
        },
        loadCategories() {
          this.busy = true
          this.error = null
          return axios.get(`/org/${this.organization.id}/categories`)
          .then(response => {
            this.busy = false
            let categories = response.data
            if (this.block.meta && this.block.meta.form && this.block.meta.form.category_id) {
                this.categories = [this.findWithChild(categories, this.block.meta.form.category_id)]
            } else {
                this.categories = categories
            }
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        },
        loadClasses() {
          if (this.block.meta && this.block.meta.items_type && !this.block.meta.items_type.includes('classes')){
            return new Promise((resolve) =>  {return resolve()})
          }
          this.busy = true
          this.error = null
          return axios.get(`/org/${this.organization.id}/classes?am_only=true&no_pagination=true`)
          .then(response => {
            this.busy = false
            let classes = []
            response.data.classes.map((event) => {
                if (event.microsite_registration_questions && event.microsite_registration_questions.length > 0) {
                    event.microsite_registration_questions.map((microEvent) => {
                        let newEvent = {...event}
                            newEvent.id = microEvent.id
                            newEvent.name = microEvent.label
                            newEvent.microsite_registration_questions = [microEvent]
                            classes.push(newEvent)
                    });
                }
            });
            this.items.push(...classes)
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        },
        mountProducts() {
          this.products = this.items
        /*this.$nextTick(function () {
            _.each(this.$refs.productRef, vm => {
                vm.invoice = this.invoice
            });
        })*/
        },
        load(){
            this.items = []
            this.loadMemberships().then(this.loadProducts).then(this.loadClasses).then(this.loadCategories).then(this.loadCart).then(this.mountProducts).then(() => {
                if (this.categories[0].children && this.categories[0].children[0]){
                    document.querySelector(`[id^="tab-id-${this.categories[0].children[0].id}${this.block.id}"]`).click()
                } else {
                    document.querySelector(`[id^="tab-id-${this.categories[0].id}${this.block.id}"]`).click()
                }
                // todo: if no products in category find the next one that has categories

            })
        },
        switchForm(ucid, id){
            let url = `/org/${this.organization.id}/cart/switch_form_public/${ucid}`
            this.error = null
            axios.patch(url, {form_id: id})
            .then(response => {
                this.busy = false
                //this.$emit('invoice', response.data)
            })
            .catch(error => {
                this.error = _.errorFromAjax(error)
            })
        },
      },
      computed: {
        getColSize(){
            let itemSize = this.block.meta && this.block.meta.form ? this.block.meta.form.item_size : 0.25
            let size = "md-4"
            switch (itemSize) {
                case 0.25:
                    size = "md-3"
                break;
                case 0.5:
                    size = "md-6"
                break;
                case 1.0:
                    size = "md-12"
                break;
            }
            return size
        },
      },
      mounted() {
        window.ecommerceTabs = this
        this.load()
      },
    }
  </script>
